"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _imageUrlModifier = require("../../utils/imageUrlModifier/imageUrlModifier");
var _SaleTagFilled = require("../icons/SaleTagFilled");
var _colourModule = _interopRequireDefault(require("./colour.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var propTypes = {
  /** The unique id of the colour */
  id: _propTypes.default.string,
  /** The swatch image of the colour */
  swatch: _propTypes.default.string.isRequired,
  /** The name of the colour */
  name: _propTypes.default.string.isRequired,
  /** The value of the colour */
  value: _propTypes.default.string,
  /** The type of the underlying input element */
  type: _propTypes.default.oneOf(['radio', 'checkbox']),
  /** Whether the colour is unavailable */
  unavailable: _propTypes.default.bool,
  /** Whether the colour is selected */
  selected: _propTypes.default.bool,
  /** If the input is disabled */
  disabled: _propTypes.default.bool,
  /** Function to be called when a colour is selected, should be set via ColourList component */
  onClick: _propTypes.default.func,
  /** Displays the Reduced text below the colour label */
  hasReducedPrice: _propTypes.default.bool,
  /** Displays the given text as label or by default `Reduced` text will be displayed */
  reducedPriceText: _propTypes.default.string,
  /** Displays black price instead of colour offers when the product is Dior*/
  isDior: _propTypes.default.bool
};
var Colour = function Colour(_ref) {
  var _ref$isDior = _ref.isDior,
    isDior = _ref$isDior === void 0 ? false : _ref$isDior,
    swatch = _ref.swatch,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    name = _ref.name,
    _ref$unavailable = _ref.unavailable,
    unavailable = _ref$unavailable === void 0 ? false : _ref$unavailable,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hasReducedPrice = _ref.hasReducedPrice,
    hasReducedPrice = _ref$hasReducedPrice === void 0 ? false : _ref$hasReducedPrice,
    _ref$reducedPriceText = _ref.reducedPriceText,
    reducedPriceText = _ref$reducedPriceText === void 0 ? 'Reduced' : _ref$reducedPriceText,
    _ref$Tag = _ref.Tag,
    Tag = _ref$Tag === void 0 ? 'input' : _ref$Tag,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps;
  var classes = (0, _classnames.default)(_colourModule.default['c-colour__label'], _defineProperty(_defineProperty({}, _colourModule.default['c-colour__label--unavailable'], unavailable), _colourModule.default['c-colour__label--selected'], selected));
  var inputId = id || "".concat(name, "_").concat(value);
  var label = hasReducedPrice ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: _colourModule.default['c-colour__label--reduced'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _colourModule.default['c-colour__label-text'],
      children: value
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames.default)(_colourModule.default['c-colour__label-text'], _defineProperty({}, _colourModule.default['c-colour__label-promo'], !isDior)),
      children: reducedPriceText
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: _colourModule.default['c-colour__label-text'],
    children: value
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _colourModule.default['c-colour'],
    "data-jlds": true,
    children: Tag === 'input' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        checked: selected,
        className: _colourModule.default['c-colour__input'],
        disabled: disabled,
        id: inputId,
        name: name,
        onChange: function onChange(e) {
          return _onClick(e.target.value);
        },
        type: type,
        value: value
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
        className: classes,
        htmlFor: inputId,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _colourModule.default['c-colour__swatch'],
          style: {
            backgroundImage: "url(".concat((0, _imageUrlModifier.formatAmplienceImageURL)(swatch), ")")
          }
        }), label, (unavailable || selected) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: _colourModule.default['c-colour__properties'],
          children: [selected && ' selected', unavailable && ' currently unavailable']
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tag, _objectSpread(_objectSpread({
      className: (0, _classnames.default)(classes, _defineProperty(_defineProperty({}, _colourModule.default['c-colour__label--selected'], selected), _colourModule.default['c-colour__label--disabled'], disabled)),
      "data-testid": "colour:option:button",
      onClick: function onClick() {
        if (!disabled) {
          _onClick(value || children);
        }
      },
      tabIndex: disabled ? -1 : undefined,
      type: Tag === 'button' ? 'button' : undefined
    }, buttonProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _colourModule.default['c-colour__swatch'],
        style: {
          backgroundImage: "url(".concat((0, _imageUrlModifier.formatAmplienceImageURL)(swatch), ")")
        }
      }), label, (unavailable || selected) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: _colourModule.default['c-colour__properties'],
        children: [selected && ' selected', unavailable && ' currently unavailable']
      })]
    }))
  });
};
Colour.propTypes = propTypes;
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Colour);